module["exports"] = [
  "ca",
  "com",
  "biz",
  "info",
  "name",
  "net",
  "org"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_CA/internet/domain_suffix.js
 ** module id = 504
 ** module chunks = 0
 **/